export const SET_ERROR_MESSAGE='SET_ERROR_MESSAGE';
export const HIDE_ERROR_PANEL='HIDE_ERROR_PANEL';